import { useQuery } from '@tanstack/react-query';

import { getHowDidYouHearAboutUsOptions } from 'api/jalapeno';

const fetchHowDidYouHeadAboutUs = async () => {
    const response = await getHowDidYouHearAboutUsOptions();

    return {
        ...response.data,
    };
};

export const HOW_DID_YOU_HEAR_ABOUT_US_QUERY_KEY = 'how-did-you-hear-about-us';

const useHowDidYouHearAboutUsQuery = ({ extendedQueryKeys = [], queryProps } = {}) => {
    const query = useQuery({
        queryKey: [HOW_DID_YOU_HEAR_ABOUT_US_QUERY_KEY, ...extendedQueryKeys],
        queryFn: () => fetchHowDidYouHeadAboutUs(),
        ...queryProps,
    });

    return query;
};

export default useHowDidYouHearAboutUsQuery;
